// extracted by mini-css-extract-plugin
export var optionGrid = "_60-7";
export var optionList = "_60-6";
export var questionsBlock = "_60-9";
export var spacer = "_60-5";
export var stepCenteredContent = "_60-3";
export var stepInner = "_60-0";
export var stepInnerFullWidth = "_60-1";
export var stepInnerLockScroll = "_60-2";
export var stepTransitionFrame = "_60-4";
export var welcomeBlock = "_60-8";